{
  document.addEventListener("DOMContentLoaded", () => {
    const marquee = document.querySelector(".LoopMarque");
    if (!marquee) return;

    const originalItems = [...marquee.querySelectorAll(".slider__item")];
    if (!originalItems.length) return;

    const setupMarquee = () => {
      // Remove previous clones
      marquee.querySelectorAll(".marquee-clone").forEach((el) => el.remove());

      // Kill previous animation
      if (marquee._marqueeAnimation) {
        marquee._marqueeAnimation.kill();
      }

      // Calculate original items width
      const itemsWidth = originalItems.reduce(
        (total, item) => total + item.offsetWidth,
        0
      );

      if (!itemsWidth) return;

      const screenWidth = window.innerWidth;

      // How many copies are needed to fill the screen
      const copies = Math.ceil(screenWidth / itemsWidth) + 2;

      // Duplicate original items
      for (let i = 0; i < copies; i++) {
        originalItems.forEach((item) => {
          const clone = item.cloneNode(true);
          clone.classList.add("marquee-clone");
          marquee.appendChild(clone);
        });
      }

      // Width of one complete original set
      const distance = itemsWidth;

      // GSAP animation
      const animation = gsap.to(marquee, {
        x: -distance,
        duration: distance / 50,
        ease: "none",
        repeat: -1,
      });

      marquee._marqueeAnimation = animation;

      // Pause on mouse hover
      marquee.addEventListener("mouseenter", () => {
        animation.pause();
      });

      marquee.addEventListener("mouseleave", () => {
        animation.resume();
      });
    };

    setupMarquee();

    // Recalculate on resize
    let resizeTimer;

    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(() => {
        setupMarquee();
      }, 300);
    });
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
    const allAccordions = document.querySelectorAll(".accordion_cus");
    allAccordions.forEach((accordion) => {
      const items = accordion.querySelectorAll(".acco_cus_item");
      if (items.length > 0) {
        items[0].classList.add("open");
      }
      items.forEach((item) => {
        const header = item.querySelector(".acc-header");
        header.addEventListener("click", () => {
          items.forEach((otherItem) => {
            if (otherItem !== item && otherItem.classList.contains("open")) {
              otherItem.classList.remove("open");
            }
          });
          item.classList.toggle("open");
        });
      });
    });
  });
}

{
      (() => {
  function initProductPopups() {
    document.querySelectorAll('.popup-product-wrapper').forEach((wrapper) => {
      
      // Prevent duplicate event listeners
      if (wrapper.dataset.popupInitialized === 'true') return;

      const openBtn = wrapper.querySelector('.popup-product-open-btn');
      const popup = wrapper.querySelector('.popup-product');
      const closeBtn = wrapper.querySelector('.popup-product-close-btn');

      if (!popup) return;

      wrapper.dataset.popupInitialized = 'true';

      openBtn?.addEventListener('click', () => {
        popup.style.display = 'flex';
        popup.style.animation = 'none';

        requestAnimationFrame(() => {
          popup.style.animation = 'fadeIn 0.5s forwards';
        });
      });

      closeBtn?.addEventListener('click', () => {
        popup.style.display = 'none';
      });

      popup.addEventListener('click', (e) => {
        if (e.target === popup) {
          popup.style.display = 'none';
        }
      });
    });
  }

  // Initial page load
  initProductPopups();

  // Shopify Theme Editor
  document.addEventListener('shopify:section:load', initProductPopups);

  // AJAX/dynamic content support
  const observer = new MutationObserver(() => {
    initProductPopups();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
}